import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 382C1 356 16 346 44 346L362 332L462 36C471 11 485 0 500 0C514 0 528 11 536 36L636 332L954 346C984 347 998 356 998 382C998 405 992 414 978 424L712 590L828 950C835 972 828 984 810 994C793 1004 773 1002 758 990L500 752L240 990C228 1002 206 1003 188 994C168 984 163 972 170 950L286 590L20 424C6 414 -1 404 0 382Z" })
});
export default SvgStarFill;
